import { useEffect, useState } from "react";
import { Bot, Briefcase, Megaphone, Search, UserPlus, Wallet } from "lucide-react";
import { Mascot } from "./Script";
import { reducedMotion } from "../../lib/motion";

const MiniSite = ({ small }) => (
  <div className={`mini ${small ? "small" : ""}`}>
    <div className="mini-nav"><b>Votre marque</b><i /><i /><i /></div>
    <div className="mini-hero">
      <img src="/media/mountain-day-560.webp" alt="" width="560" height="376" loading="lazy" decoding="async" />
      <div><b>Propulsez votre activité</b><span>Découvrir</span></div>
    </div>
    <div className="mini-grid"><i /><i /><i /><i /></div>
  </div>
);

export const SitesVisual = () => (
  <div className="vis vis-sites" aria-hidden="true" data-testid="visual-sites">
    <div className="vis-in">
      <div className="mon"><div className="mon-screen"><MiniSite /></div><div className="mon-stand" /></div>
      <div className="lap small-lap"><div className="lap-screen"><MiniSite small /></div><div className="lap-base" /></div>
      <div className="phone site-phone"><MiniSite small /></div>
    </div>
  </div>
);

const ASSISTANTS = [[Briefcase, "CEO", "violet"], [UserPlus, "Prospects", "magenta"], [Bot, "Clients / SAV", "cyan"],
  [Wallet, "Finance", "amber"], [Megaphone, "Marketing", "magenta"], [Search, "Recherche", "cyan"]];

export const JarvisVisual = () => (
  <div className="vis vis-jarvis" data-testid="visual-jarvis">
    <div className="vis-in">
      <img className="jv-box" src="/media/jarvis-agents-ia-720.webp" srcSet="/media/jarvis-agents-ia-720.webp 720w, /media/jarvis-agents-ia-1264.webp 1264w"
        sizes="(max-width: 960px) 70vw, 34vw" width="720" height="483" alt="Pack Jarvis IA : un ensemble d’assistants IA (ChatGPT, Claude, Gemini…) pour votre activité" loading="lazy" decoding="async" />
      <div className="phone jv-phone" aria-hidden="true">
        <b>Vos assistants</b>
        {ASSISTANTS.map(([Icon, label, c]) => <div key={label} className="ph-row" style={{ "--c": `var(--${c})` }}><Icon /><span>{label}</span><em>Prêt</em></div>)}
      </div>
      <Mascot kind="magenta" className="jv-mascot" />
    </div>
  </div>
);

const FEED = ['{ "sku": "JUM-OLV",', '  "nom": "Jumelles terrain",', '  "stock": "disponible",', '  "maj": "automatique" },',
  '{ "sku": "BOT-CUIR",', '  "nom": "Chaussures de marche",', '  "stock": "disponible" },', '{ "sku": "VES-FOR",', '  "nom": "Veste de terrain" }'];
const PRODUCTS = [["binoculars", "Jumelles terrain"], ["boots", "Chaussures de marche"], ["jacket", "Veste de terrain"]];
export const INTEG_CHIPS = ["API revendeur", "E-commerce", "ERP / CRM", "Marketplaces", "Outils métiers"];

const Feed = () => {
  const [t, setT] = useState(0);
  useEffect(() => {
    if (reducedMotion()) return undefined;
    const id = setInterval(() => setT((x) => (x + 1) % FEED.length), 900);
    return () => clearInterval(id);
  }, []);
  return <pre className="feed">{FEED.map((l, i) => <span key={l} className={i === t ? "hl" : ""}>{l}{"\n"}</span>)}</pre>;
};

export const IntegrationsVisual = ({ withChips = true }) => (
  <div className="vis vis-integ" data-testid="visual-integrations">
    <div className="vis-in">
      <img className="iv-bg" src="/media/sunset-hunter-720.webp" srcSet="/media/sunset-hunter-720.webp 720w, /media/sunset-hunter-1264.webp 1264w"
        sizes="(max-width: 960px) 92vw, 46vw" width="720" height="483" alt="Chasseur et son chien au coucher du soleil" loading="lazy" decoding="async" />
      <div className="lap iv-lap" aria-hidden="true"><div className="lap-screen"><Feed /></div><div className="lap-base" /></div>
      <div className="iv-cards" aria-hidden="true">
        {PRODUCTS.map(([k, n]) => (
          <div key={k} className="iv-card"><img src={`/media/product-${k}-320.webp`} alt="" width="320" height="320" loading="lazy" decoding="async" /><b>{n}</b><em>Synchronisé</em></div>
        ))}
      </div>
      {withChips && <ul className="iv-chips" data-testid="integrations-chips">{INTEG_CHIPS.map((c) => <li key={c}>{c}</li>)}</ul>}
    </div>
    <figure className="iv-partner">
      <img src="/brand/partenariat-rog-novasoft.webp" alt="Logo partenariat RoG Hunting × NovaSoft" width="1774" height="887" loading="lazy" decoding="async" />
      <figcaption data-testid="integrations-rog-caption">Exemple : catalogue revendeur RoG Hunting synchronisé</figcaption>
    </figure>
  </div>
);
